/**
 * Enum for sorting
 * @readonly
 * @enum {Object}
 */
export const SORT_TYPE = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});